import BarChartIcon from '@mui/icons-material/BarChart';

export const menus = [
    {
        title: 'Criminalidade',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsecurity/criminal-data',
        gap: true
    },
    {
        title: 'Veiculos Subtraídos',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsecurity/vehicles',
        gap: true
    },
    {
        title: 'Celulares Subtraídos',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsecurity/phones',
        gap: true
    },
    {
        title: 'Objetos Subtraídos',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsecurity/objects',
        gap: true
    },
    {
        title: 'Mortes por Intervenção Policial',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsecurity/deathsByPoliceIntervention',
        gap: true
    },
    {
        title: 'IML',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsecurity/iml',
        gap: true
    },
];
